<template>
  <div style="font-weight: bold; margin-left: 5px; max-width: 450px">
    <!-- 游客 -->
    <template v-if="!otherUserInfo.roleId">
      {{ `${$t('游客')}` }}
      <template v-if="otherUserInfo.userName || otherUserInfo.ipLocation">
        {{ `(${otherUserInfo.userName} ${otherUserInfo.ipLocation})` }}
      </template>
    </template>
    <!-- 企业用户 -->
    <template
      v-else-if="
        otherUserInfo.companyName &&
        (otherUserInfo.companyFlag === 0 ||
          Number(otherUserInfo.roleId) === 2 ||
          Number(otherUserInfo.roleId) === 3 ||
          Number(otherUserInfo.roleId) === 4)
      "
    >
      {{ otherUserInfo.userName }} ({{ msg.ext && msg.ext.company ? msg.ext.company : otherUserInfo.companyName }})
    </template>
    <!-- 个人用户 -->
    <template v-else>
      {{ otherUserInfo.userName || otherUserInfo.memberUserName }}
      ({{ otherUserInfo.phone }}{{ otherUserInfo.phone && otherUserInfo.email ? ' / ' : '' }}{{ otherUserInfo.email }})
    </template>
  </div>
</template>
<script>
export default {
  name: 'OtherHeader',
  props: {
    otherUserInfo: {
      type: Object,
      default: () => {
        return {
          userName: '',
          memberUserName: '',
          phone: '',
          email: '',
          companyName: '',
          companyFlag: 0,
          roleId: 0,
          ipLocation: '',
        }
      },
    },
    msg: {
      type: Object,
      default: () => {
        return {
          ext: {
            company: '',
          },
        }
      },
    },
  },
}
</script>
